import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { ObligationDeleteModel } from 'src/Models/ObligationUpdatesModel';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { UsersService } from 'src/Services/users.service';
import { View47DeleteService } from 'src/Services/view47-delete.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-cfo-frontdelete',
  templateUrl: './cfo-frontdelete.component.html',
  styleUrls: ['./cfo-frontdelete.component.css']
})
export class CfoFrontdeleteComponent implements OnInit {

  stateCode: any;
  userId: number = 0;
  _userID: string = "";

  tokenKey: string;
  PageNumber: number = 1;
  PageSize: number;
  OrderBy: string;

  upDowTitleCSS: string = '';
  upDowDetailsCSS: string = '';
  upDowcfrCSS: string = '';
  upDowCarrierNameCSS: string = '';
  upDowcategoryTypeNameCSS: string = '';
  upDowdeleteDeleteDeleteCSS: string = '';

  isAscending: boolean = true;
  isRecord: boolean = false;
  isloading: boolean = false;
  totalRecordCount: number = 0;
  OrderByName: string = 'cfr';

  blockedDocument = false;
  isShowprogressSpinner = false;
  listofDelete!: ObligationDeleteModel[];
  exportlistofDelete!: ObligationDeleteModel[];

  INTERNALINTESERRAUSERS: boolean = false;
  @ViewChild("ObligationModel", { static: false }) ObligationModel!: ElementRef;
  obligationTitle: string = '';
  obligationDetails: string = '';
  applicableto: string = '';
  cfrdetails: string = '';
  cfrurl: string = '';
  cfrsection: string = '';
  ch: string = '';
  chSub: string = '';
  part: string = '';
  subPart: string = '';
  auditornotes: string = '';
  deleteDeleteDelete: string = '';
  federalregisternumber: string = '';
  federalregisternumberurl: string = '';

  IsPending: boolean = false;
  IsDelete: boolean = false;
  baseUrl: string;
  canDownload: boolean = false;
  ProductId: number = 0;

  PendingHoverText: string = '';
  DeleteHoverText: string = '';

  //CategoryType
  dropdownSettingsCategoryFilter = {};
  dropdownCategoryFilter = [];
  selectedCategoryItems = [];
  listOfCategoryTypeIDs = [];
  categoryTypeList: any[] = [];
  listOfCategoryTypeName = [];
  categoryId: string = ' ';
  Note: string = '';
  SearchItem: string = '';

  constructor(private readonly appActivity: ApplicationActivityService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly view47DeleteService: View47DeleteService,
    private readonly htmlToPdf: HtmlToPdf,
    private readonly userService: UsersService,
    private sessionStorageService: SessionStorageService,
    @Inject('BASE_URL') baseUrl: string) {

    let Inteseraemailid = localStorage.getItem('useremail');
    this.baseUrl = baseUrl;

    if (Inteseraemailid != '' && Inteseraemailid != null) {
      if (Inteseraemailid.indexOf('@inteserra.com') !== -1 || Inteseraemailid.indexOf('@jsitel.com') !== -1 || Inteseraemailid.indexOf('@fastektax.com') !== -1 || Inteseraemailid.indexOf('@aceinfoway.com') !== -1) {
        this.INTERNALINTESERRAUSERS = true;
      }
      else {
        this.INTERNALINTESERRAUSERS = false;
      }
    }
    else {
      this.INTERNALINTESERRAUSERS = false;
    }

    const appStartTime = sessionStorage.getItem('appStartTime');
    const tokenExpiryValue = sessionStorage.getItem('tokenExpiryValue');

    if (appStartTime !== null && tokenExpiryValue !== null) {
      this.tokenExpireCalculation(appStartTime, tokenExpiryValue);
    }

    this._userID = sessionStorage.getItem('UserId') || '';
    this.ProductId = ToolEnum.View47;

    sessionStorage.setItem('tokenValue', this.sessionStorageService.getTokenValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();

    this.titleService.setTitle('Delete, Delete, Delete | JSi360');
    this.OrderBy = 'cfr DESC';
    this.upDowcfrCSS = 'active-up';
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsCategoryFilter = {
      singleSelection: false,
      text: "Filter by Status",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Category Type(s) available',
      showCheckbox: true
    };


    this.getCanDownload();
    this.getCategoryType();
    this.GetDeleteActivity();
  }

  resetPageNoandSize() {
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  GetDeleteActivity() {
    this.isloading = true;
    this.categoryId = ' ';
    if (this.listOfCategoryTypeIDs.length > 0) {
      this.categoryId = this.listOfCategoryTypeIDs.join(',')
    }

    ApplicationActivityStore('View', 'View 47 Delete, Delete, Delete Activity', this.appActivity, ToolEnum.View47, ActionActivity['View 47'], '/View/View47-delete');
    this.view47DeleteService.GetAllFrontView47DeleteByUser(this.tokenKey, this.PageNumber, this.PageSize, this.OrderBy, parseInt(this._userID), this.Note, this.categoryId, false).subscribe(
      data => {
        this.isloading = false;
        this.listofDelete = data['obligationdelete'];

        if (this.listofDelete != null) {
          if (this.listofDelete.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofDelete[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
      error => { this.stateCode = error }
    );
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';
      this.upDowTitleCSS = '';
      this.upDowDetailsCSS = '';
      this.upDowcfrCSS = '';
      this.upDowCarrierNameCSS = '';
      this.upDowcategoryTypeNameCSS = '';
      this.upDowdeleteDeleteDeleteCSS = '';

      if (sortBy === "title") {
        this.upDowTitleCSS = 'active-up';
      }
      else if (sortBy === "details") {
        this.upDowDetailsCSS = 'active-up';
      }
      else if (sortBy === "cfr") {
        this.upDowcfrCSS = 'active-up';
      }
      else if (sortBy === "carrierTypeName") {
        this.upDowCarrierNameCSS = 'active-up';
      }
      else if (sortBy === "categoryTypeName") {
        this.upDowcategoryTypeNameCSS = 'active-up';
      }
      else if (sortBy === "deleteDeleteDelete") {
        this.upDowdeleteDeleteDeleteCSS = 'active-up';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;
      this.upDowTitleCSS = '';
      this.upDowDetailsCSS = '';
      this.upDowcfrCSS = '';
      this.upDowCarrierNameCSS = '';
      this.upDowcategoryTypeNameCSS = '';
      this.upDowdeleteDeleteDeleteCSS = '';


      if (sortBy === "title") {
        this.upDowTitleCSS = 'active';
      }
      else if (sortBy === "details") {
        this.upDowDetailsCSS = 'active';
      }
      else if (sortBy === "cfr") {
        this.upDowcfrCSS = 'active';
      }
      else if (sortBy === "carrierTypeName") {
        this.upDowCarrierNameCSS = 'active';
      }
      else if (sortBy === "categoryTypeName") {
        this.upDowcategoryTypeNameCSS = 'active';
      }
      else if (sortBy === "deleteDeleteDelete") {
        this.upDowdeleteDeleteDeleteCSS = 'active';
      }
    }
    this.OrderByName = sortBy;
    this.resetPageNoandSize();
    this.GetDeleteActivity();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetDeleteActivity();
  }

  replaceCommaLines(data) {
    let str = '';
    let dataToArray = data.split(',').map(item => item.trim());
    dataToArray.forEach((element, index) => {

      if ((dataToArray.length - 1) == index) {
        str = str + element;
      }
      else {
        if (((index + 1) % 3) == 0) {
          str = str + element + "<br />";
        }
        else { str = str + element + ','; }
      }
    });

    return str
  }

  getPageLength() {
    return Math.min((this.PageNumber * this.PageSize), this.totalRecordCount);
  }

  cfrLinkView(linkurl) {
    ApplicationActivityStore('Click Link', 'Delete, Delete, Delete', this.appActivity, ToolEnum.View47, ActionActivity['View 47'], linkurl);
  }

  viewObligation(Id: number) {
    this.ObligationModel.nativeElement.click();

    this.view47DeleteService.GetView47DeleteById(this.tokenKey, Id).subscribe(
      (data: any) => {
        let itemData = data['obligation'];
        ApplicationActivityStore(
          'View',
          'Delete, Delete, Delete',
          this.appActivity,
          ToolEnum.View47,
          ActionActivity['View 47'],
          itemData.title
        );

        // Category
        var categoryNames = [];

        if (itemData.categoryTypeId != null && itemData.categoryTypeId.length > 0) {
          categoryNames = itemData.categoryTypeId.map(function (item) {
            return item.categoryName;
          });
        }

        this.IsPending = categoryNames.indexOf('Pending') > -1;
        this.IsDelete = categoryNames.indexOf('Deleted') > -1;

        this.obligationTitle = itemData.title;
        this.obligationDetails = itemData.details;
        this.cfrdetails = itemData.cfr;
        this.cfrurl = itemData.url;

        // Carrier
        if (itemData.carrierTypeId != null && itemData.carrierTypeId.length > 0) {
          this.applicableto = itemData.carrierTypeId
            .map(function (item) {
              return item.carrierName;
            })
            .join(', ');
        } else {
          this.applicableto = '';
        }

        this.cfrsection = itemData.cfrSection;
        this.ch = itemData.ch;
        this.chSub = itemData.subCh;
        this.part = itemData.part;
        this.subPart = itemData.subPart;
        this.deleteDeleteDelete = itemData.deleteDeleteDelete;
        this.auditornotes = itemData.auditornotes;
        this.federalregisternumber = itemData.federalregisternumber;
        this.federalregisternumberurl = itemData.federalregisternumberurl;
      },
      (error) => {
        this.stateCode = error;
      }
    );
  }


  GetExportDeleteActivity() {
    this.categoryId = ' ';
    if (this.listOfCategoryTypeIDs.length > 0) {
      this.categoryId = this.listOfCategoryTypeIDs.join(',')
    }

    this.blockDocument();
    ApplicationActivityStore('Export', 'View 47 Delete, Delete, Delete Activity', this.appActivity, ToolEnum.View47, ActionActivity['View 47'], '/View/View47-delete');
    this.view47DeleteService.GetAllFrontView47DeleteByUser(this.tokenKey, this.PageNumber, this.PageSize, this.OrderBy, parseInt(this._userID), this.Note, this.categoryId, true).subscribe(
      data => {
        this.exportlistofDelete = data['obligationdelete'];

        setTimeout(() => {
          this.createMyPdf();
        }, 1500);

      },
      error => {
        this.stateCode = error
        this.unblockDocument();
      }
    );
  }

  createMyPdf() {
    let mainURL = this.baseUrl;
    let url = ''
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Front/bootstrap.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Front/pdfstyle.css">';


    var html = url + document.getElementById('divPrint').innerHTML;
    this.htmlToPdf.CreatePDF(this.tokenKey, html, '0', ToolEnum.View47).
      subscribe(data => {
        if (data['status'] == 'Success') {
          this.downloadFile('FCCDeleteDeleteDeleteActivityReport.pdf', data['url'], data['fileName']);
        }
      },
        error => {
          this.unblockDocument();
        }
      );
  }
  public downloadFile(filename: any, url: any, orignalFileName: any) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        ApplicationActivityStore('Download', 'CRRA File download ' + filename, this.appActivity, ToolEnum.crra, ActionActivity.CRRA, '/View/rulesView');
        sessionStorage.setItem('fileloading', 'false');
        this.htmlToPdf.DeletePDF(this.tokenKey, orignalFileName).subscribe(
          data => {
            this.unblockDocument();
          },
        );
      }
    );
  }

  getCanDownload() {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.userService.ExportCitiationSubscriptionGetByUser(this.tokenKey, parseInt(this._userID), this.ProductId).subscribe(
      data => {
        if (data != null) {
          if (data['exportCitiation'].length > 0) {
            this.canDownload = true;
          }
          else
            this.canDownload = false;
        }
      },
      error => { }
    );
  }

  getCategoryType() {
    this.view47DeleteService.GetView47DeleteCategory(this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.categoryTypeList = result['category'];
          if (this.categoryTypeList.length > 0) {
            for (let i = 0; i < this.categoryTypeList.length; i++) {
              if (this.categoryTypeList[i].categoryName == "Initial") {
                this.PendingHoverText = this.categoryTypeList[i].mouseoverText;
              }
              else if (this.categoryTypeList[i].categoryName == "Maintenance") {
                this.DeleteHoverText = this.categoryTypeList[i].mouseoverText;
              }
            }
          }
          this.dropdownCategoryFilter = [];
          this.categoryTypeList.forEach(x => {
            this.dropdownCategoryFilter.push({ "id": x.categoryTypeId, "itemName": x.categoryName })
          });
        }
      },
      error => { }
    );
  }

  onSelectCategory($event) {
    this.listOfCategoryTypeIDs = this.removeElemetninArray(this.listOfCategoryTypeIDs, $event.id)
    this.listOfCategoryTypeName = this.removeElemetninArray(this.listOfCategoryTypeName, $event.itemName)
    this.listOfCategoryTypeIDs.push($event.id);
    this.listOfCategoryTypeName.push($event.itemName);
    this.resetPageNoandSize();
    this.GetDeleteActivity();
  }

  onDeSelectCategory($event) {

    if (this.listOfCategoryTypeIDs != null) {
      if (this.listOfCategoryTypeIDs.length > 0) {
        this.listOfCategoryTypeIDs = this.removeElemetninArray(this.listOfCategoryTypeIDs, $event.id)
      }
    }

    if (this.listOfCategoryTypeName != null) {
      if (this.listOfCategoryTypeName.length > 0) {
        this.listOfCategoryTypeName = this.removeElemetninArray(this.listOfCategoryTypeName, $event.itemName)
      }
    }
    this.resetPageNoandSize();
    this.GetDeleteActivity();
  }

  onSelectAllCategory($event) {
    for (const item of $event) {
      if (this.listOfCategoryTypeIDs != null) {
        if (this.listOfCategoryTypeIDs.length > 0) {
          this.listOfCategoryTypeIDs = this.removeElemetninArray(this.listOfCategoryTypeIDs, item.id)
          this.listOfCategoryTypeIDs.push(item.id);
        }
        else {
          this.listOfCategoryTypeIDs.push(item.id);
        }
      }

      if (this.listOfCategoryTypeName != null) {
        if (this.listOfCategoryTypeName.length > 0) {
          this.listOfCategoryTypeName = this.removeElemetninArray(this.listOfCategoryTypeName, item.itemName)
          this.listOfCategoryTypeName.push(item.itemName);
        }
        else {
          this.listOfCategoryTypeName.push(item.itemName);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetDeleteActivity();
  }

  onDeSelectAllCategory($event) {
    this.listOfCategoryTypeIDs = [];
    this.listOfCategoryTypeName = [];
    this.resetPageNoandSize();
    this.GetDeleteActivity();
  }

  clear() {
    this.resetPageNoandSize();
    this.selectedCategoryItems = [];
    this.listOfCategoryTypeIDs = [];

    this.Note = '';
    this.SearchItem = "";
    this.GetDeleteActivity();
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.Note = $event.target.value;
    else this.Note = '';

    this.GetDeleteActivity();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }
}